module.exports = __webpack_public_path__ + "static/img/t3.11186073.jpg";